var React = require('react');

function SChevronUpMedium18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.69673,10.28184,9.70734,6.30245A1,1,0,0,0,8.29313,6.302l-.00047.00047L4.30327,10.28184A.9999.9999,0,1,0,5.715,11.69828l.00237-.00237L9,8.41324l3.28266,3.28267a.9999.9999,0,1,0,1.41644-1.4117Z","fill":"var(--iconFill, #464646)"}));
}

SChevronUpMedium18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SChevronUpMedium18N;

SChevronUpMedium18N.default = SChevronUpMedium18N;
